module.exports = __webpack_public_path__ + "img/android.a6975442.svg";